<!-- SUPPLIER PREVIEW  -->
@if (msfps.isBuyerManagementPreview && msfps.mode === "supplierEdit") {
  <!-- SUPPLIER: EXIT BUTTON - SM-1587: Use read-only exit for parent-shared forms -->
  <button
    type="button"
    class="btn btn-outline-primary ms-2"
    (click)="msfps.isParentShared ? msfps.exitReadOnly() : msfps.exit()"
  >
    Exit
  </button>
}
<!-- Previous BUTTON -->
@if (msfps.getEnablePrevious()) {
  <button
    type="button"
    class="btn btn-outline-primary ms-2"
    (click)="msfps.goToPrevious()"
  >
    Previous
  </button>
}

<!-- Next BUTTON -->
@if (msfps.getEnableNext()) {
  <button
    type="button"
    class="btn btn-outline-primary ms-2"
    [disabled]="msfps.getDisableNext()"
    (click)="msfps.goToNext()"
  >
    Next
  </button>
}
<!-- SUPPLIER: SAVE BUTTON -->
@if (msfps.isBuyerManagementPreview && msfps.mode === "supplierEdit") {
  @if (!msfps.isParentShared) {
    <button type="button" class="btn btn-primary ms-2" (click)="msfps.save()">
      Save
    </button>
  }
}
<!-- BUYER MANAGEMENT PREVIEW -->
<!-- *ngIf="msfps.isBuyerManagementPreview && msfps.mode !== 'supplierEdit'" -->
@if (msfps.mode !== "supplierEdit" && msfps.mode !== "previewDisabled") {
  <!-- GET SCORES BUTTON -->
  @if (msfps.doEnableGetScoresButton()) {
    <button
      type="button"
      class="btn btn-primary ms-2"
      (click)="msfps.getScores()"
    >
      Get scores
    </button>
  }
}
<!-- SUPPLIER PREVIEW -->
@if (msfps.isBuyerManagementPreview && msfps.mode === "supplierEdit") {
  <!-- SUPPLIER: VALIDATE BUTTON -->
  <button type="button" class="d-none btn btn-primary ms-2">Validate</button>
  <!-- SUPPLIER: CCA REVIEW BUTTON - Shows calculated scores before submission -->
  @if (!msfps.isParentShared && !msfps.getEnableNext() && msfps.shouldReviewLinkedForm()) {
    <button
      type="button"
      class="btn btn-info ms-2"
      (click)="msfps.getScores(true)"
      [disabled]="!msfps.enableReviewButton"
    >
      Review
    </button>
  }
  
  <!--SUPPLIER: SUBMIT BUTTON - Hidden for CCA forms -->
  @if ((!msfps.isParentShared && !msfps.getEnableNext() && !msfps.shouldReviewLinkedForm())) {
    <button
      type="button"
      class="btn btn-primary ms-2"
      [disabled]="!msfps.enableSubmitButton"
      (click)="msfps.submitConfirm()"
    >
      Submit
    </button>
  }
}

<!-- CLOSE BUTTON -->
@if (!(msfps.isBuyerManagementPreview || msfps.mode === "supplierEdit")) {
  <button
    type="button"
    class="ms-2 btn btn-outline-dark"
    (click)="close('Close button click')"
  >
    Close
  </button>
  @if (msfps.isReviewClicked) {
    <button
      type="button"
      class="btn btn-primary ms-2"
      [disabled]="!msfps.enableSubmitButton"
      (click)="msfps.submitConfirm()"
    >
      Submit
    </button>
  }
}
